
import {Button} from "@progress/kendo-react-buttons";
import "./SubscriptionAccountButton.scss";
import  { useNavigate}  from "react-router-dom";


export const SubscriptionAccountButton = () => {

    const navigate = useNavigate();

    return (

        <Button className={"signInButton"} fillMode={"link"} onClick={() => navigate("/subscriptionProfile")}>
            <span className="k-icon k-i-settings">&nbsp;</span>View Your Subscriptions
        </Button>
    );
};
